import {
  ConnectDeclineReason,
  IConnectContact,
  IConnectRoom,
  IIncomingCall,
} from '@epicuro-next/data/connect';
import { ConnectionStatus as fromConnectData } from '@epicuro-next/models/users';
import { createReducer, on } from '@ngrx/store';

import {
  finalizeCall,
  incomingCallAccepted,
  initConnectSuccess,
  loadRoomSuccess,
  loadTwilioTokenSuccess,
  removeIncomingCall,
  setCurrentUserContactState,
  setDeclineReason,
  setIncomingCall,
  setNotificationPermissionResult,
  setRoomNameState,
  setUserConnectionStatus,
  setVideoLoading,
} from '../actions';

export const connectDataFeatureKey = 'data';

export interface DataState {
  userConnectionStatus?: fromConnectData;
  currentContact?: IConnectContact;
  twilioToken?: string;
  twilioRoom?: IConnectRoom;
  videoLoading?: boolean;
  incomingCall?: IIncomingCall | null;
  notificationPermission: NotificationPermission;
  declineReason?: ConnectDeclineReason;
  connectEnabled: boolean;
}

export const dataInitialState: DataState = {
  videoLoading: true,
  notificationPermission: 'default',
  connectEnabled: false,
};

export const dataReducer = createReducer(
  dataInitialState,
  on(
    initConnectSuccess,
    (state): DataState => ({
      ...state,
      connectEnabled: true,
    }),
  ),
  on(
    setUserConnectionStatus,
    (state, action): DataState => ({
      ...state,
      userConnectionStatus: action.status,
    }),
  ),
  on(
    setCurrentUserContactState,
    (state): DataState => ({
      ...state,
      userConnectionStatus: fromConnectData.ONCALL,
    }),
  ),
  on(
    loadTwilioTokenSuccess,
    (state, action): DataState => ({
      ...state,
      twilioToken: action.token,
    }),
  ),
  on(
    loadRoomSuccess,
    (state, action): DataState => ({
      ...state,
      twilioRoom: action.room,
    }),
  ),
  on(
    setVideoLoading,
    (state, action): DataState => ({
      ...state,
      videoLoading: action.loading,
    }),
  ),
  on(
    finalizeCall,
    (state): DataState => ({
      ...state,
      userConnectionStatus: fromConnectData.AVAILABLE,
      twilioRoom: undefined,
      twilioToken: undefined,
      incomingCall: undefined,
    }),
  ),
  on(
    setIncomingCall,
    (state, action): DataState => ({
      ...state,
      incomingCall: action.incomingCall,
    }),
  ),
  on(
    removeIncomingCall,
    (state): DataState => ({
      ...state,
      incomingCall: undefined,
    }),
  ),
  on(
    setRoomNameState,
    (state, action): DataState => ({
      ...state,
      twilioRoom: {
        name: action.roomName,
      } as IConnectRoom,
    }),
  ),
  on(
    incomingCallAccepted,
    (state, action): DataState => ({
      ...state,
      currentContact: action.contact,
    }),
  ),
  on(
    setNotificationPermissionResult,
    (state, action): DataState => ({
      ...state,
      notificationPermission: action.result,
    }),
  ),
  on(
    setDeclineReason,
    (state, action): DataState => ({
      ...state,
      declineReason: action.reason,
    }),
  ),
);
